var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "super-g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.6601 3.09333C10.1623 3.09333 11.1757 3.74222 11.7534 4.28444L14.0112 2.08C12.6245 0.791111 10.8201 0 8.6601 0C5.53121 0 2.82898 1.79556 1.51343 4.40889L4.10009 6.41778C4.74898 4.48889 6.54454 3.09333 8.6601 3.09333Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M16.34 8.17779C16.34 7.52001 16.2866 7.04001 16.1711 6.54224H8.65997V9.51113H13.0689C12.98 10.2489 12.5 11.36 11.4333 12.1067L13.9578 14.0622C15.4689 12.6667 16.34 10.6133 16.34 8.17779Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M4.10892 9.58221C3.94003 9.08443 3.84226 8.5511 3.84226 7.99999C3.84226 7.44887 3.94003 6.91554 4.10003 6.41776L1.51337 4.40887C0.971145 5.49332 0.660034 6.7111 0.660034 7.99999C0.660034 9.28887 0.971145 10.5067 1.51337 11.5911L4.10892 9.58221Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M8.66018 16C10.8202 16 12.6335 15.2889 13.958 14.0622L11.4335 12.1067C10.758 12.5778 9.85129 12.9067 8.66018 12.9067C6.54462 12.9067 4.74907 11.5111 4.10907 9.58221L1.5224 11.5911C2.83796 14.2044 5.53129 16 8.66018 16Z",
    fill: "#34A853"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.252646e19a0e70b2df84518541fff3d8.svg";
export { ForwardRef as ReactComponent };